import type { Lang } from '@/types/lang'

const DAY_MS = 24 * 60 * 60 * 1000

const compact = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 })

/** 999 → 999, 66 496 → 66.5K — для мест, где не хватает ширины. Порт академии. */
export const formatCompactNumber = (value: number): string => compact.format(value)

/** Целый рейтинг без дробной части, остальной — с одним знаком. Как в академии. */
export const formatRating = (value: number): string =>
  Number.isInteger(value) ? String(value) : value.toFixed(1)

const UNITS: Record<Lang, { d: string; w: string; mo: string; y: string; today: string }> = {
  ru: { d: 'д', w: 'нед', mo: 'мес', y: 'г', today: 'сегодня' },
  en: { d: 'd', w: 'w', mo: 'mo', y: 'y', today: 'today' },
}

/**
 * Подпись «обновлено»: сегодня / 3 д / 2 нед / 5 мес / 1 г — сокращения те же,
 * что в веб-академии. `null`, когда даты нет или она не разбирается.
 */
export const updatedAgo = (iso: string | null | undefined, lang: Lang, now = new Date()) => {
  if (!iso) return null
  const time = new Date(iso).getTime()
  if (Number.isNaN(time)) return null
  const u = UNITS[lang]
  const days = Math.max(0, Math.floor((now.getTime() - time) / DAY_MS))
  if (days >= 365) return `${Math.floor(days / 365)} ${u.y}`
  if (days >= 30) return `${Math.floor(days / 30)} ${u.mo}`
  if (days >= 7) return `${Math.floor(days / 7)} ${u.w}`
  if (days >= 1) return `${days} ${u.d}`
  return u.today
}
